<template>
    <div>

        <v-tabs color="white" slider-color="primary" v-if="hasPermission('run queries')" v-model="activeTab">

            <v-tab key="activity">
                Activity filter
            </v-tab>

            <v-tab key="category">
                Category filter
            </v-tab>

            <v-tab key="project">
                Project filter
            </v-tab>

            <v-tab key="extras">
                Extras
            </v-tab>

        </v-tabs>

        <v-tabs-items v-model="activeTab">

            <!-- ACTIVITY FILTER TAB -->
            <v-tab-item key="activity">
                <filter-activity-config
                        :active="active"
                        :operation="excludeOperation"
                        :statuses="excludeStatuses"
                        :days="excludeDays"
                        @change="dataChanged"
                ></filter-activity-config>
            </v-tab-item>

            <!-- CATEGORIES FILTER -->
            <v-tab-item key="category">
                <filter-category-config
                        :active="excludeCategoriesActive"
                        :statuses="excludeCategoriesStatuses"
                        :categories="excludeCategories"
                        :days="excludeCategoriesDays"
                        @change="dataChanged"
                ></filter-category-config>
            </v-tab-item>

            <!-- PROJECT FILTER -->
            <v-tab-item key="project">
                <filter-project-config
                    :active="projectFilterActive"
                    :project-ids="projectFilterIds"
                    :operation="projectFilterOperation"
                    :statuses="projectFilterStatuses"
                    @change="dataChanged"
                ></filter-project-config>
            </v-tab-item>

            <!-- MISC FILTER -->
            <v-tab-item key="extras">
                <filter-extras-config
                    :extras="extras"
                    @change="dataChanged"
                ></filter-extras-config>
            </v-tab-item>

        </v-tabs-items>

    </div>

</template>

<script>

    import FilterActivityConfig from "../../modules/Segments/components/FilterActivityConfig";
    import FilterCategoryConfig from "../../modules/Segments/components/FilterCategoryConfig";
    import FilterProjectConfig from "../../modules/Segments/components/FilterProjectConfig";
    import FilterExtrasConfig from "../../modules/Segments/components/FilterExtrasConfig";

    export default {

        components: {
            FilterExtrasConfig,
            FilterActivityConfig,
            FilterCategoryConfig,
            FilterProjectConfig
        },

        props: {
            active: {
                required: false,
                type: Boolean,
                default: false,
            },

            excludeOperation: {
                required: false,
                type: String,
                default: 'must_not',
            },

            excludeStatuses: {
                required: false,
                type: Array,
                default: () => ['invited'],
            },

            excludeDays: {
                required: false,
                type: Number | String,
                default: 7,
            },

            excludeCategoriesActive: {
                required: false,
                type: Boolean,
                default: false,
            },

            excludeCategories: {
                required: false,
                type: Array,
                default: () => []
            },

            excludeCategoriesStatuses: {
                required: false,
                type: Array,
                default: () => ['invited'],
            },

            excludeCategoriesDays: {
                required: false,
                type: Number | String,
                default: 31,
            },

            projectFilterActive: {
                required: false,
                type: Boolean,
                default: false,
            },

            projectFilterIds: {
                required: false,
                type: Array,
                default: null,
            },

            projectFilterOperation: {
                required: false,
                type: String,
                default: 'must',
                validator: (value) => {
                    return ['must','must_not'].includes(value)
                }
            },

            projectFilterStatuses: {
                required: false,
                type: Array,
                default: () => []
            },

            extras: {
                required: false,
                type: Array,
                default: () => []
            },

            defaultTab: {
                required: false,
                type: Number,
                default: 0
            }
        },

        watch: {
            defaultTab: function (defaultTab) {
                this.activeTab = defaultTab;
            },
        },

        data() {
            return {
                activeTab: null,
                tabHeight: 350,
            }
        },

        methods: {

            dataChanged(config) {
                this.$emit('change', config);
            },
        }
    }
</script>
